import React, { useState } from "react";
import { Alert } from "reactstrap";

interface CustomAlertProps {
  color?: string;
  content: string;
  isShow: boolean;
  errorList?: Array<string>;
}

export default function CustomAlert({
  color = "info",
  content,
  isShow,
  errorList,
}: CustomAlertProps) {
  if (errorList) {
    return (
      <Alert color={color} isOpen={isShow}>
        <h4>{content}</h4>
        <ol>
          {errorList.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ol>
      </Alert>
    );
  }
  return (
    <Alert color={color} isOpen={isShow}>
      <span style={{ whiteSpace: "pre-line" }}>{content}</span>
    </Alert>
  );
}
